<template>
  <div>
    <v-dialog v-model="dialog" fullscreen scrollable>
      <v-card>
        <v-toolbar dark flat absolute color="primary" width="100%">
          <v-toolbar-title>{{termsAndConditions.title}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="disagree">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <!-- <v-toolbar-items>
            <v-btn dark text @click="close"> Save </v-btn>            
          </v-toolbar-items> -->
        </v-toolbar>
        <v-card-title></v-card-title>   
        <v-card-text  style="margin-top:100px;" >
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12" align="left">
                <div>
                  <h1>{{termsAndConditions.title}}</h1>
                  <div v-html="termsAndConditions.html"></div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>          
          <v-row style="margin-bottom:10px !important;">
            <v-col cols="12" align="right" style="margin-right:20px"> 
              <v-container >
                <v-form 
                  ref="form"
                  v-model="valid"
                  lazy-validation>                       
                  <v-checkbox
                    v-model="agreement"                
                    align="right"
                    :rules="[v => !!v || '']"
                    label="I have read and agree to the Terms and Conditions"
                  ></v-checkbox>   
                  <v-alert
                    text
                    v-model="alert"               
                    dismissible
                    border="left"
                    type="error"                    
                    style="text-align:left"
                  >                              
                   Please indicate that you have read and agree to the terms and conditions.
                  </v-alert>   
                  <v-btn color="success" @click="agree">
                    <v-icon left>mdi-checkbox-marked-circle</v-icon>{{termsAndConditions.confirmButtonText}}</v-btn>               
                  <v-btn color="error" @click="disagree" >
                    <v-icon dark left> mdi-cancel</v-icon>{{termsAndConditions.cancelButtonText}}</v-btn>
                </v-form>                
              </v-container>
            </v-col>
          </v-row>  
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import config from '../Campaign/config';
export default {
  name: 'Influencer-Terms-Modal',
  props: {
    dialog: Boolean,
    dialogTitle: String,
    value: Boolean
  },
  data () {
    return {
      termsAndConditions: config.campaignConfirmation.influencerContractTermsAndCondition,
      showContractModal: false,
      agreement: '',
      valid: true,
      alert: false
    }
  },
  methods: {
    agree: function() {
      this.$refs.form.validate()
      if (this.$refs.form.validate()) {
        this.$emit('termsAggrement', true);
        this.$emit('input');
      }
    },
    disagree: function() {
      this.$emit('termsAggrement', false);
      this.$emit('input');
    }
  }
};
</script>




// WEBPACK FOOTER //
// InfluencerTermsModal.vue?11800b70